import { IndividualCounselingProjectContentsForm } from "./Main";

export const Register = () => {
  return <IndividualCounselingProjectContentsForm />;
};
